module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_5012.bd7f95c7.png";